import {showNotification} from "../../alert/alert.js"

export default function setup() {
    function loadAvatarView() {
        // Make an AJAX call to load the form from the controller
        $.ajax({
            url: '/Account/GetAvatarImage',
            type: 'GET',
            success: function (response) {
                // Load the form into the container
                $('.private-seller-avatar-container').html(response);
                initializeAvatarImageUpdateFormHandlers();
            },
            error: function (error) {
                showNotification("Avatar was not loaded", "error");
            }
        });
    }

    loadAvatarView();

    function loadPasswordChangeView() {
        // Make an AJAX call to load the form from the controller
        $.ajax({
            url: '/PasswordRecovery/SetNewPasswordFromAccount',
            type: 'GET',
            success: function (response) {
                // Load the form into the container
                $('.private-seller-password-container').html(response);
                initializeChangePasswordFormHandlers();
            },
            error: function (error) {
                showNotification("Set new password form was not loaded", "error");
            }
        });
    }

    loadPasswordChangeView();

    function initializeChangePasswordFormHandlers() {

        // Initially disable the button
        $('#set-new-password-from-account-button').prop('disabled', true);

        // Function to check if password fields are filled
        function checkPasswordFields() {
            var password = $('#SetNewPasswordFromAccount #Password').val();

            // Enable the button only if both password fields are filled
            if (password) {
                $('#set-new-password-from-account-button').prop('disabled', false);
            } else {
                $('#set-new-password-from-account-button').prop('disabled', true);
            }
        }

        // Trigger check when password fields change
        $('#SetNewPasswordFromAccount #Password').on('input', checkPasswordFields);

        $('#set-new-password-from-account-button').on('click', function (e) {

            if ($(this).prop('disabled')) {
                e.preventDefault();  // Prevent the click event from going further
                return;
            }
            // Collect the form data
            var form = $('#SetNewPasswordFromAccount');
            var formData = form.serialize();

            // Send the form via AJAX
            $.ajax({
                url: '/PasswordRecovery/SetNewPasswordFromAccount',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                success: function (response) {
                    $('.private-seller-password-container').html(response);
                    initializeChangePasswordFormHandlers();
                },
                error: function (xhr, status, error) {
                    showNotification("New password was not set", "error");
                }
            });
        });
    }

    function initializeChangeSocialNetworksFormHandlers() {
        $('#set-social-networks-for-user-button').on('click', function () {
            // Collect the form data
            var form = $('#SetSocialNetworksForUser');
            var formData = form.serialize();

            // Send the form via AJAX
            $.ajax({
                url: '/PrivateSellerEditProfile/SetSocialNetworksForUser',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                success: function (response) {
                    $('.private-seller-social-networks-container').html(response);
                    initializeChangeSocialNetworksFormHandlers();
                },
                error: function (xhr, status, error) {
                    showNotification("Social networks were not set", "error");
                }
            }).always(function() {
                triggerUpdateOfPassword();
            });
        });
    }

    function initializeAvatarImageUpdateFormHandlers() {

        // Initially disable the button
        $('#updateAvatarImage').prop('disabled', true);

        // Check when the file input changes
        $('#AvatarImageFileAttachment').on('change', function () {
            var fileInput = $(this);
            // Enable the button if a file is selected, otherwise disable it
            if (fileInput.val()) {
                $('#updateAvatarImage').prop('disabled', false);
            } else {
                $('#updateAvatarImage').prop('disabled', true);
            }
        });

        $('#updateAvatarImage').on('click', function (e) {

            if ($(this).prop('disabled')) {
                e.preventDefault();  // Prevent the click event from going further
                triggerUpdateOfPrivateSellerProfile();
                return;
            }
            // Collect the form data
            // Collect the form data, including the file
            var form = $('#avatarImageUpdateForm')[0];  // Get the raw DOM element
            var formData = new FormData(form);          // Create a FormData object

            // Send the form via AJAX
            $.ajax({
                url: '/Account/UpdateAvatarImage',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                processData: false,  // Important: Prevent jQuery from automatically transforming the data into a query string
                contentType: false,  // Important: Let the browser set the `Content-Type` with `multipart/form-data` boundary
                success: function (response) {
                    $('.private-seller-avatar-container').html(response);
                    initializeAvatarImageUpdateFormHandlers();
                },
                error: function (xhr, status, error) {
                    showNotification("Avatar image was not updated", "error");
                }
            }).always(function () {
                // This code will run whether the request succeeds or fails
                triggerUpdateOfPrivateSellerProfile();
            });
        });
    }

    function triggerUpdateOfPrivateSellerProfile() {
        $("#update-private-seller-profile-info").trigger("click");
    }

    function loadPrivateSellerProfileView() {
        // Make an AJAX call to load the form from the controller
        $.ajax({
            url: '/PrivateSellerEditProfile/UpdateProfile',
            type: 'GET',
            success: function (response) {
                // Load the form into the container
                $('.private-seller-profile-info-container').html(response);
                initializePrivateSellerProfileFormHandlers();
            },
            error: function (error) {
                showNotification("User profile was not loaded", "error");
            }
        });
    }

    loadPrivateSellerProfileView();

    function initializePrivateSellerProfileFormHandlers() {
        $('#update-private-seller-profile-info').on('click', function () {
            // Collect the form data
            var form = $('#profileUpdateForm');
            var formData = form.serialize();

            // Send the form via AJAX
            $.ajax({
                url: '/PrivateSellerEditProfile/UpdateProfile',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                success: function (response) {
                    $('.private-seller-profile-info-container').html(response);
                    initializePrivateSellerProfileFormHandlers();
                },
                error: function (xhr, status, error) {
                    showNotification("User profile was not updated", "error");
                }
            }).always(function() {
                triggerUpdateOfSocialNetworks();
            });
        });
    }

    function loadSocialNetworkChangeView() {
        // Make an AJAX call to load the form from the controller
        $.ajax({
            url: '/PrivateSellerEditProfile/SetSocialNetworksForUser',
            type: 'GET',
            success: function (response) {
                // Load the form into the container
                $('.private-seller-social-networks-container').html(response);
                initializeChangeSocialNetworksFormHandlers();
            },
            error: function (error) {
                showNotification("Social networks form was not loaded", "error");
            }
        });
    }

    loadSocialNetworkChangeView();

    function loadConfirmChangesView() {
        // Make an AJAX call to load the form from the controller
        $.ajax({
            url: '/PrivateSellerEditProfile/GetConfirmPasswordToSaveChangesForm',
            type: 'GET',
            success: function (response) {
                // Load the form into the container
                $('.confirm-changes-container').html(response);
                initializeConfirmChangesViewFormHandlers();
            },
            error: function (error) {
                showNotification("Confirm changes form was not loaded", "error");
            }
        });
    }

    loadConfirmChangesView();

    function initializeConfirmChangesViewFormHandlers() {

        $('#ConfirmPasswordToSaveChangesForm #toggle-password-icon').on('mousedown', function() {
            var passwordInput = $('#ConfirmPasswordToSaveChangesForm #Password');
            var icon = $(this).find('i');
            icon.removeClass('fa-eye-slash').addClass('fa-eye');
            passwordInput.attr('type', 'text'); // Show the password while the button is pressed
        });

        $('#ConfirmPasswordToSaveChangesForm #toggle-password-icon').on('mouseup mouseleave', function() {
            var passwordInput = $('#ConfirmPasswordToSaveChangesForm #Password');
            var icon = $(this).find('i');
            icon.removeClass('fa-eye').addClass('fa-eye-slash');
            passwordInput.attr('type', 'password'); // Hide the password when the button is released
        });
        
        $('#confirm-password-to-save-changes-button').on('click', function () {
            
            // Collect the form data
            var form = $('#ConfirmPasswordToSaveChangesForm');
            var formData = form.serialize();

            // Send the form via AJAX
            $.ajax({
                url: '/PrivateSellerEditProfile/ConfirmPasswordToSaveChanges',  // The action method that handles the form submission
                type: 'POST',
                data: formData,
                success: function (response) {
                    submitAllForms();
                    showNotification("Changes saved successfully!", "success");
                },
                error: function (xhr, status, error) {
                    showNotification("Error saving changes. Please try again.", "error");
                }
            });
        });
    }

    // Function to submit all other forms on the page
    function submitAllForms() {
        $("#updateAvatarImage").trigger("click");
    }
    function triggerUpdateOfPassword() {
        $("#set-new-password-from-account-button").trigger("click");
    }
    function triggerUpdateOfSocialNetworks() {
        $("#set-social-networks-for-user-button").trigger("click");
    }
    
}